<script>
    export default {
        name: "dialog-body",
        props: {
            minHeight: Number,
            maxHeight: Number,
        },
        computed: {
            style() {
                const style = {};
                if (!_.isUndefined(this.minHeight) && !_.isUndefined(this.maxHeight)) {
                    console.error('Cannot set css property max- and min-height at the same time');
                }
                if (!_.isUndefined(this.minHeight)) style.minHeight = `${this.minHeight}px`;
                if (!_.isUndefined(this.maxHeight)) style.maxHeight = `${this.maxHeight}px`;

                return style;
            }
        }
    }
</script>

<template>
    <div :style="style">
        <slot/>
    </div>
</template>

